// extracted by mini-css-extract-plugin
module.exports = {"mine":"Navbar_mine__uioHt","logo":"Navbar_logo__1YM9H"};